"use strict";

(() => {
	/******************************************************************/
	/* GLOBALS
	/******************************************************************/

	const menuDrawer = document.querySelector('#menu-drawer');
	const searchAccountBar = document.querySelector('.header__search');
	const searchTrigger = document.querySelector('.menu-drawer__menu__search-trigger');

	/******************************************************************/
	/* Mobile Navigation
	/******************************************************************/


	// FOR TESTING: OPEN NAV DRAWER
	// setTimeout(() => {
	// 	document.querySelector("#open-mobile-nav").click()
	// }, 1000);

	/******************************************************************/
	/* Search modal handling
	/******************************************************************/

	searchTrigger.addEventListener('click', () => {
		document.querySelector('.header__search').click();
	});
	
	/******************************************************************/
	/* Menu/Submenu handling
	/******************************************************************/

	const menu = menuDrawer.querySelector('.menu-drawer__menu');

	const changeMenuLevel = (newLevel) => {
		searchAccountBar.setAttribute('data-level', newLevel);
		menu.setAttribute('data-level', newLevel);
	}

	(() => {
		// first to second level
		const parentNavItems = menuDrawer.querySelectorAll('.menu-drawer__navItem--parent');

		parentNavItems.forEach((parentNavItem) => {
			parentNavItem.addEventListener('click', (e) => {
				if(e.currentTarget.tagName === 'A') return;

				// only one submenu may be open at a time; clicks can open a new
				// parent while another is still open (e.g. taps during the slide
				// transition or programmatic clicks from bestseller triggers)
				menuDrawer.querySelectorAll('.menu-drawer__navItem--open').forEach((openItem) => {
					if (openItem !== parentNavItem) {
						openItem.classList.remove('menu-drawer__navItem--open');
					}
				});

				parentNavItem.classList.add('menu-drawer__navItem--open');
				changeMenuLevel(1);
			});
		});

		// back from second to first level
		const submenuBackButtons = menuDrawer.querySelectorAll('.menu-drawer__navItem__submenu__prevButton');

		submenuBackButtons.forEach((backButton) => {
			backButton.addEventListener('click', (e) => {
				e.stopPropagation();
				e.preventDefault();
				backButton.parentElement.parentElement.parentElement.classList.remove('menu-drawer__navItem--open');
				changeMenuLevel(0);
			});
		});

		// reset submenu state when the drawer closes, so reopening shows the root list
		const menuDrawerContainer = document.querySelector('.menu-drawer-container');

		const resetSubmenuState = () => {
			menuDrawer.querySelectorAll('.menu-drawer__navItem--open').forEach((openItem) => {
				openItem.classList.remove('menu-drawer__navItem--open');
			});
			changeMenuLevel(0);
		};

		let pendingSubmenuReset = null;

		menuDrawerContainer?.addEventListener('toggle', () => {
			if (menuDrawerContainer.open) {
				// reopened before the delayed reset ran: reset now, otherwise the
				// drawer would reopen on the stale submenu instead of the root list
				if (pendingSubmenuReset !== null) {
					clearTimeout(pendingSubmenuReset);
					pendingSubmenuReset = null;
					resetSubmenuState();
				}
				return;
			}

			// wait for the drawer close transition, so the reset isn't visible
			pendingSubmenuReset = setTimeout(() => {
				pendingSubmenuReset = null;
				resetSubmenuState();
			}, 400);
		});
	})();

	const getVisibleHeight = (element) => {
		if (!element) return 0;
		const rect = element.getBoundingClientRect();
		if (rect.bottom <= 0) return 0;
		if (rect.top < 0) return rect.bottom;
		return element.offsetHeight;
	}

	const updateCssVariables = (useVisibleHeight = false) => {
		const announcementBar = document.querySelector('.announcement-bar.sticky');
		const customHeader = document.querySelector('.header.header-custom');
		const mobileFooter = document.querySelector('.menu-drawer__footer');
		const mobileBestsellers = document.querySelector('.menu-drawer__menu__recommendations');
		
		let announcementHeight = 0;
		let headerHeight = 0;

		if (useVisibleHeight) {
			announcementHeight = announcementBar ? getVisibleHeight(announcementBar) : 0;
			headerHeight = customHeader ? getVisibleHeight(customHeader) : 0;
		} else {
			announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
			headerHeight = customHeader ? customHeader.offsetHeight : 0;
		}

		if (customHeader && announcementBar) {
			document.documentElement.style.setProperty('--header-announcement-height', `${announcementHeight}px`);
			document.documentElement.style.setProperty('--custom-header-height', `${headerHeight}px`);
			document.documentElement.style.setProperty('--header-total', `${announcementHeight + headerHeight}px`);
		} else if (customHeader) {
			document.documentElement.style.setProperty('--header-announcement-height', '0px');
			document.documentElement.style.setProperty('--custom-header-height', `${headerHeight}px`);
			document.documentElement.style.setProperty('--header-total', `${headerHeight}px`);
		}

		document.documentElement.style.setProperty('--mobile-footer-height', `${mobileFooter?.offsetHeight ?? 47}px`);
		document.documentElement.style.setProperty('--mobile-bestsellers-height', `${mobileBestsellers?.offsetHeight ?? 228}px`);
	}

	window.addEventListener('resize', () => {
		updateCssVariables();
	});

	let scrollTimeout;
	const sectionCustomHeader = document.querySelector('.section-custom-header');
	const useVisibleHeightOnScroll = sectionCustomHeader?.dataset.useVisibleHeightOnScroll === 'true';
	
	window.addEventListener('scroll', () => {
		if (scrollTimeout) {
			cancelAnimationFrame(scrollTimeout);
		}
		
		scrollTimeout = requestAnimationFrame(() => {
			updateCssVariables(useVisibleHeightOnScroll);
		});
	});

	document.addEventListener('action-bar-closed', () => {
		updateCssVariables(true);
	});

	const subSubmenuItems = document.querySelectorAll('.header__subSubmenuItem, .header__submenuItem');

	subSubmenuItems.forEach((subSubmenuItem) => {
		const isSubSubItem = subSubmenuItem.classList.contains('header__subSubmenuItem');

		subSubmenuItem.addEventListener('mouseover', () => {
			const bannerId = subSubmenuItem.getAttribute('id');
			const banner = document.querySelector(`.header__submenu__banner[id="${bannerId}"]`);

			if(banner) {
				banner.classList.add('header__submenu__banner--active');
				if(isSubSubItem) {
					banner.style.zIndex = '2';
				}
			}
		});

		subSubmenuItem.addEventListener('mouseout', () => {
			const bannerId = subSubmenuItem.getAttribute('id');
			const banner = document.querySelector(`.header__submenu__banner[id="${bannerId}"]`);

			if(banner) {
				banner.classList.remove('header__submenu__banner--active');
				if(isSubSubItem) {
					banner.style.zIndex = '';
				}
			}
		});
	});

	updateCssVariables();

	const drawerResizeObserver = new ResizeObserver(() => updateCssVariables());
	document.querySelectorAll('.menu-drawer__footer, .menu-drawer__menu__recommendations')
		.forEach((el) => drawerResizeObserver.observe(el));

	const menuDrawerAccountTrigger = document.querySelector('.menu-drawer__footer__account-trigger');
	const accountButton = document.querySelector('.header-custom dialog-component .account-button');

	if(!accountButton || !menuDrawerAccountTrigger) return;

	menuDrawerAccountTrigger.addEventListener('click', () => {
		accountButton.click();
	});
})();